import { render, staticRenderFns } from "./materialTemplate.vue?vue&type=template&id=fbd85db8&scoped=true"
import script from "./materialTemplate.vue?vue&type=script&lang=js"
export * from "./materialTemplate.vue?vue&type=script&lang=js"
import style0 from "./materialTemplate.vue?vue&type=style&index=0&id=fbd85db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd85db8",
  null
  
)

export default component.exports